import {
  Component,
  Inject,
  Input,
  OnInit
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterDialogData, TableData } from '../../../model/model';
import { FilterService } from '../../../shared/filter.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-filterpopup',
    templateUrl: './filterpopup.component.html',
    styleUrl: './filterpopup.component.css',
    standalone: false
})
export class FilterpopupComponent implements OnInit {
  @Input() columnData: TableData[] = [];
  selectedValues: boolean[] = [];
  isApplyDisabled = true;
  isSelectAllChecked = false;

  constructor(
    private readonly dialogRef: MatDialogRef<FilterpopupComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: FilterDialogData,
    private readonly filterService: FilterService
  ) {
    this.columnData = data.columnData;
  }

  ngOnInit(): void {
    const savedFilterValues = this.filterService.getFilter(
      this.data.columnName
    );
    this.selectedValues = this.columnData.map(value =>
      savedFilterValues.includes(value)
    );
    this.updateApplyButton();
    this.updateSelectAll();
  }

  applyFilter(): void {
    const filterValues = this.columnData.filter(
      (_, index) => this.selectedValues[index]
    );
    this.filterService.setFilter(this.data.columnName, filterValues);
    this.dialogRef.close(filterValues);
  }

  updateApplyButton(){
    this.isApplyDisabled = !this.selectedValues.some(value => value);
  }

  updateSelectAll(){
    this.isSelectAllChecked = this.selectedValues.every(value => value)
  }

  toggleSelectAll(event: MatCheckboxChange){
    this.isSelectAllChecked = event.checked;
    this.selectedValues = this.columnData.map(() => this.isSelectAllChecked);
    this.updateApplyButton();
  }

  toggleSelection(index: number) {
    this.selectedValues[index] = !this.selectedValues[index];
    this.updateApplyButton();
    this.updateSelectAll();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
